import { motion } from "framer-motion";
import { Check } from "lucide-react";

const facts = [
  "Two videographers on every booking for full coverage",
  "Experienced team filming 100+ weddings per year",
  "Natural, unobtrusive approach. Guests forget we are there",
  "High-end cinematic editing with individually colour graded films",
  "Photography and videography designed to match in style",
  "Fast turnaround. Sneak peek highlight film within 72 hours",
  "900+ weddings filmed across Essex, London, Kent, and the South East",
  "Award-winning. 7x Wedding Awards winner with a 5.0 average rating",
  "Recommended by 21 wedding venues across Essex",
  "No hidden charges. Interest free monthly payments available",
];

export default function WhyChooseUs() {
  return (
    <section
      id="why"
      data-testid="why-choose-section"
      className="bg-[#FAF9F7] py-24 md:py-32"
      aria-label="Why choose Wedding Video Essex as your wedding videographer and photographer"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="max-w-3xl mb-12"
        >
          <p className="text-xs tracking-[0.2em] uppercase text-[#C2A878] font-sans mb-4">
            Why couples choose us
          </p>
          <h2
            data-testid="why-choose-heading"
            className="font-serif text-2xl sm:text-3xl lg:text-4xl tracking-tight font-light text-[#1A1917] leading-tight"
          >
            Why choose Wedding Video Essex
          </h2>
          <p className="mt-4 text-sm text-[#5A5750] font-sans leading-relaxed">
            We are a specialist wedding videography and photography team based in Wickford, Essex.
            Here is what sets us apart.
          </p>
        </motion.div>

        <ul className="space-y-4">
          {facts.map((fact, i) => (
            <motion.li
              key={fact}
              initial={{ opacity: 0, x: -10 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.04 }}
              data-testid={`why-fact-${i}`}
              className="flex items-start gap-3"
            >
              <Check
                size={16}
                className="mt-1 flex-shrink-0 text-[#C2A878]"
              />
              <span className="text-sm md:text-base text-[#3A3835] font-sans leading-relaxed">
                {fact}
              </span>
            </motion.li>
          ))}
        </ul>
      </div>
    </section>
  );
}
